import { AUDIENCE_TYPES, AUDIENCE_TYPES_ARRAY } from "posts/constants";
import Card, { CardTitle } from "./Card";
import React, { useState } from "react";

import Artifact from "./Artifact";
import CompareModal from "./CompareModal";
import { getAudienceTypeColor } from "utils/styles";
import styled from "styled-components";
import { getAudienceEmoji } from "posts/constants";

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const Tag = styled.span.attrs({ className: "mabry-medium" })`
  font-size: 1.125rem;
  display: block;
  padding: 0.5rem 1rem;
  margin-right: 1rem;
  margin-bottom: 1rem;
  border-radius: 10px;
  background: ${({ activeAudience }) => {
    return getAudienceTypeColor(activeAudience);
  }};
`;

function InterestsCard({ activeAudience }) {
  const [showCompare, setShowCompare] = useState(false);

  const renderContent = (audience, small) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return (
          <Wrapper>
            <Tag activeAudience={audience}>Pandemic</Tag>
            <Tag activeAudience={audience}>Do It Yourself</Tag>
            <Tag activeAudience={audience}>Christian</Tag>
            <Tag activeAudience={audience}>America</Tag>
            <Tag activeAudience={audience}>Politics</Tag>
            <Tag activeAudience={audience}>Tutorial</Tag>
            <Tag activeAudience={audience}>Classic</Tag>
            <Tag activeAudience={audience}>Country</Tag>
            <Tag activeAudience={audience}>Funny</Tag>
            <Tag activeAudience={audience}>Quarantine</Tag>
          </Wrapper>
        );
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return (
          <Wrapper>
            <Tag activeAudience={audience}>Chevrolet</Tag>
            <Tag activeAudience={audience}>Football</Tag>
            <Tag activeAudience={audience}>Oldies</Tag>
            <Tag activeAudience={audience}>Survival</Tag>
            <Tag activeAudience={audience}>Gold</Tag>
            <Tag activeAudience={audience}>Tools</Tag>
            <Tag activeAudience={audience}>Technology</Tag>
            <Tag activeAudience={audience}>Safety</Tag>
            <Tag activeAudience={audience}>Horse</Tag>
            <Tag activeAudience={audience}>Installation</Tag>
          </Wrapper>
        );
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return (
          <Wrapper>
            <Tag activeAudience={audience}>Workout</Tag>
            <Tag activeAudience={audience}>Natural hair</Tag>
            <Tag activeAudience={audience}>Meditation</Tag>
            <Tag activeAudience={audience}>Asmr</Tag>
            <Tag activeAudience={audience}>Hip hop</Tag>
            <Tag activeAudience={audience}>Kids</Tag>
            <Tag activeAudience={audience}>Fashion</Tag>
            <Tag activeAudience={audience}>Relationships</Tag>
            <Tag activeAudience={audience}>Education</Tag>
            <Tag activeAudience={audience}>Mixtape</Tag>
          </Wrapper>
        );
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return (
          <Wrapper>
            <Tag activeAudience={audience}>Minecraft</Tag>
            <Tag activeAudience={audience}>Reaction</Tag>
            <Tag activeAudience={audience}>Meme</Tag>
            <Tag activeAudience={audience}>Anime</Tag>
            <Tag activeAudience={audience}>Kpop</Tag>
            <Tag activeAudience={audience}>Playthrough</Tag>
            <Tag activeAudience={audience}>Trending</Tag>
            <Tag activeAudience={audience}>Rage</Tag>
            <Tag activeAudience={audience}>Mario</Tag>
            <Tag activeAudience={audience}>Twitch</Tag>
          </Wrapper>
        );
    }
  };

  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        Top Tags
      </CardTitle>
      {renderContent(activeAudience)}
      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>Compare Audiences – Interests</CompareModal.Title>
        </CompareModal.Header>
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`voices-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    {renderContent(type, true)}
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}

export default InterestsCard;
